<div *ngIf=" memberAssocationStore !== undefined && (data|async) as member">
  <div class="block">
    <div class = "organization-info" *ngIf="member.Founded !== 0">
      <p *ngIf="member.CName"><strong>{{member.MaName}}</strong> {{'member.federation.one'|transloco}} <strong>{{member.CName}}</strong></p>
      <p>{{'member.federation.founded' | transloco}} <strong>{{member.Founded}}</strong><span *ngIf="member.Affiliated"> {{'member.federation.affiliated' | transloco}} <strong>{{member.Affiliated}}</strong></span>.</p>
    </div>

  <div class="block-inline">
    <div class="container">
      <div *ngIf="member.Address.Latitude != undefined; else notFound" style="width: 100%; max-width: 1000px;">
        <div class="container__map">
          <div style="height: 300px; max-height: 380px" leaflet [leafletOptions]="optionsMap">
            <div [leafletLayers]="layers"></div>
          </div>
        </div>
      </div>

      <ng-template #notFound>
        <img class="container__not-found" style="max-height: 380px;" src="../../../../../../modules/custom/wa_angular/app/assets/images/assets-maps/location_not_found.png"/>
        <div class="container__centered"><strong>{{'location_not_available' | transloco}}</strong></div>
      </ng-template>
    </div>

    <div class="contact__block">
      <h2>{{'contact_info' | transloco}}</h2>
      <div class = "address">
        <i class="icon--address"></i>{{'Address' | transloco}}: {{member?.Address.Address}}, {{member?.Address.Place}}, {{member?.Address.Zip}}, {{member?.Address.State}} {{  member?.Address.ContryName}}
      </div>
      &nbsp;
      <div class = "phone"  *ngIf="member?.Links?.Phone || member?.Links?.Mobile">
        <a class="icon--phone" *ngFor="let phone of provideTelephone(member)">{{phone}}</a>
      </div>
      &nbsp;

      <div class = "mail" *ngIf="provideEmail(member).length>0">
        <div class = "mail">
          <a [href]="'mailto:'  + email" class="icon--email" *ngFor="let email of provideEmail(member)">{{email}}</a>
        </div>
      </div>  &nbsp;

      <div class = "web" *ngIf="member?.Links?.Web">
        <a class="icon--web" [href]="member?.Links?.Web">{{member?.Links?.Web}}</a> </div>
        <div class = "social-media">
          <ng-container  *ngIf="member?.SocialMedia">
            <a [href]="member?.SocialMedia['Facebook Official Page']" class="icon--facebook" *ngIf="member?.SocialMedia['Facebook Official Page']"></a>
            <a [href]="member?.SocialMedia['Twitter Account']" class="icon--twitter"  *ngIf="member?.SocialMedia['Twitter Account']"></a>
            <a [href]="member?.SocialMedia['Instagram']" class="icon--instagram"  *ngIf="member?.SocialMedia['Instagram Account']"></a>
            <a [href]="member?.SocialMedia['YouTube channel']" class="icon--youtube"  *ngIf="member?.SocialMedia['Youtube Account']"></a>
          </ng-container>
        </div>
    </div>
  </div>
</div>

<div class="people-block">
  <h2 *ngIf="member?.Functions.length>0">{{'People' | transloco}}</h2>
  <div class="pfp-ranking">
    <div *ngFor="let member of member.Functions" class="pfp-ranking__item">
      <a>
        <img class="athlete__photo" [lazyLoad]="'//extranet.worldarchery.sport/ProfilePictures/?Id=' + member.Id" />
        <lib-athlete-name [fname]="member.FName" [gname]="member.GName" [wnameord]="member.WNameOrd"
          [id]="member.Id"></lib-athlete-name>
        <div class="pfp-ranking__cat">{{member.Function}}</div>
      </a>
    </div>
  </div>
</div>
</div>
